import * as RoutePathConstants from '../../../../constants/RoutePathConstants'
import writeOffOperation from '../write-off-operation/views/write-off-operation'

export default [
  {
    path: RoutePathConstants.WRITE_OFF_OPERATION,
    name: 'writeOffOperation',
    component: writeOffOperation
  }
]



// WEBPACK FOOTER //
// ./src/pages/wx-member/go-out-management/write-off-operation/routers.js